module.exports = __webpack_public_path__ + "static/img/Sub beam 2,4m (hollow 40x40x2,4m).6da2a05.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/Sub beam 2,4m (hollow 40x40x2,4m).jpg
// module id = 100
// module chunks = 1